import { render, staticRenderFns } from "./TftResult.vue?vue&type=template&id=11025f4c&"
import script from "./TftResult.vue?vue&type=script&lang=js&"
export * from "./TftResult.vue?vue&type=script&lang=js&"
import style0 from "./TftResult.vue?vue&type=style&index=0&id=11025f4c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports